import * as MDICONS from '@material-ui/icons';
import React from 'react'
const initState = {
    // Please do not change the values of variable
    projectReq: 0,
    companyReq: 1,
    projectAcp: 2,
    companyAcp: 3,
    companyCct: 4,

    notificationColor: {
        0: 'red',
        1: 'green',
        2: 'red',
        3: 'green',
        4: 'blue',
        5: 'black',
    },

    notificationIcon: {
        0: <MDICONS.Dvr />,
        1: <MDICONS.Apartment />,
        2: <MDICONS.Dvr />,
        3: <MDICONS.Apartment />,
        4: <MDICONS.Looks />,
        5: <MDICONS.Report />,
    },
}

const notificationReducer = (state = initState, action) => {
    if (action.type === "READ_THIS_NOTIFICATION") {
        return {
            ...state,
        }
    }
    return state;
}

export default notificationReducer;